import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { genEditValActionTypes } from '../actions/actionTypes';
import { updateFilterReducer, updateTableConfig } from './utilities/utility';

export const REDUCER_NAME = 'GenEditValuesFilterList';

const logGevListReq = (state, action) => ({
  ...state,
  listRequest: action.data ? action.data : state.listRequest,
  listRequestedOn: new Date(),
  loading: true,
});

const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
  loading: false,
});
const getEditItemDetailsResponse = (state, action) => ({
  ...state,
  getEditItemDetails: action.data,
});

const resetListValue = (state, action) => ({
  ...state,
  listSortOptions: action.data.sortOptions,
  listColumnOrder: action.data.columnOrder,
  listGroupBy: action.data ? action.data.detail.groupByParameters : null,
  isDistinctActive: action.data ? action.data.detail.isDistinct : null,
});

function GenEditValuesFilterListConfig(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    // config list column configuration
    case genEditValActionTypes.UPDATE_GEV_FILTER_CONFIG:
      return {
        ...state,
        ...updateFilterReducer(action),
      };
      // Configure Page Details
    case genEditValActionTypes.REMOVE_GEV_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };
    case genEditValActionTypes.UPDATE_GEV_COLUMN_CONFIG:
      return resetListValue(state, action);
    case genEditValActionTypes.UPDATE_TABLE_CONFIGURATION:
      return updateTableConfig(state, action);
    // log request
    case genEditValActionTypes.LOG_GEV_LIST_REQUEST:
      return logGevListReq(state, action);
    // log error
    case genEditValActionTypes.GET_GEV_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    // store response
    case genEditValActionTypes.GET_GEV_LIST_RESPONSE:
      return {
        ...state,
        listData: action.data,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    default:
      return null;
  }
}

function GenEditValuesFilterListREQRES(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    // config list column configuration
    case genEditValActionTypes.GET_GEV_BY_ID_RESPONSE:
      return getEditItemDetailsResponse(state, action);
    case genEditValActionTypes.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    case commonTypes.RESETSTORE:
      return basicFilterInitialState;
    default:
      return null;
  }
}

const GenEditValuesFilterList = (state = { ...basicFilterInitialState }, action = null) => {
  const stateConfig = GenEditValuesFilterListConfig(state, action);
  const stateReqRes = GenEditValuesFilterListREQRES(state, action);
  if (stateConfig !== null) {
    return stateConfig;
  }
  if (stateReqRes !== null) {
    return stateReqRes;
  }
  return state;
};

export default GenEditValuesFilterList;
